import Home from '@/pages/Home';
import Card from '@/pages/Card';
import CardTwo from '@/pages/Card-Two';
import CardThree from '@/pages/Card-Three';
import CardFour from '@/pages/Card-Four';

const routes = [
    {
        path: '/',
        component: Home,
        name: 'home'
    },    
    {
        path: '/card',
        component: Card,
        name: 'card'
    },
    {
        path: '/card-2',
        component: CardTwo,
        name: 'card-2'
    },
    {
        path: '/card-3',
        component: CardThree,
        name: 'card-3'
    },
    {
        path: '/card-4',
        component: CardFour,
        name: 'card-4'
    },
];

export default routes;